export default "__VITE_ASSET__DLGLgUyP__"